type Interval = { start: number; end: number }
type Padding = { before: number; after: number }

/** Pixel padding for invisible targets, returned in the original interval order. */
export function timelineHitPadding(intervals: Interval[], width: number, minimumWidth = 14): Padding[] {
  const result = intervals.map(() => ({ before: 0, after: 0 }))
  if (width <= 0) return result
  const ordered = intervals.map((interval, index) => ({ ...interval, index }))
    .sort((a, b) => a.start - b.start)

  ordered.forEach((interval, index) => {
    // Split each offline gap at its midpoint. Neither recording's expanded
    // target may claim the other half, even when both bars are very short.
    const previous = ordered[index - 1]
    const next = ordered[index + 1]
    const roomBefore = Math.max(0, previous ? (interval.start - previous.end) / 2 : interval.start)
    const roomAfter = Math.max(0, next ? (next.start - interval.end) / 2 : width - interval.end)
    const extra = Math.max(0, minimumWidth - (interval.end - interval.start))
    let before = Math.min(extra / 2, roomBefore)
    const after = Math.min(extra - before, roomAfter)
    // At a graph edge, use the other side to reach the minimum when possible.
    before = Math.min(extra - after, roomBefore)
    result[interval.index] = { before, after }
  })
  return result
}
